export default "__VITE_ASSET__DnOhMFNw__"